import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setActiveCostType = (
  state: MapState,
  action: PayloadAction<MapState['routes']['activeCostType']>
) => {
  state.routes.activeCostType = action.payload;
}
